module.exports = __webpack_public_path__ + "img/V67.43cadd32.jpg";